/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drawer_Sort_OldestInputs */

const en_drawer_sort_oldest = /** @type {(inputs: Drawer_Sort_OldestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oldest`)
};

const id_drawer_sort_oldest = /** @type {(inputs: Drawer_Sort_OldestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlama`)
};

/**
* | output |
* | --- |
* | "Oldest" |
*
* @param {Drawer_Sort_OldestInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const drawer_sort_oldest = /** @type {((inputs?: Drawer_Sort_OldestInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drawer_Sort_OldestInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_drawer_sort_oldest(inputs)
	return en_drawer_sort_oldest(inputs)
});